import axios from 'Axios';
import Vue from 'vue';

const webSockets = {
	state:{
		RecodeLogin:"",
		msg:"",
		problem:'',
	},
	mutations:{
		GET_WEB_SOCKET:(state,view)=>{
			state[view.type] = view.data;
		}
	},
	actions:{

	}
}
export default webSockets


// WEBPACK FOOTER //
// ./src/store/modules/webSocketStore.js